/* istanbul ignore file */
import { Breakpoint } from './constants.js';
import { generateMediaQuery } from './generateMediaQuery.js';
export const media = {
    phone: (options) => generateMediaQuery(Breakpoint.PHONE, options),
    tablet: (options) => generateMediaQuery(Breakpoint.TABLET, options),
    desktop: (options) => generateMediaQuery(Breakpoint.DESKTOP, options),
    wide: (options) => generateMediaQuery(Breakpoint.WIDE, options),
};
